import { Box, styled } from "@mui/material";

export const Container = styled(Box)`
  margin-right: 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  color: gray;

  font-size: 1.1em;
  font-weight: bold;

  & > svg {
    margin-right: -10px;
  }

  &:hover {
    color: gray;
  }
`;
